module.exports = __webpack_public_path__ + "static/media/423.4cdd4140.png";